var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clear bcw buybar",attrs:{"id":"fixedBtn"}},[_c('div',{staticClass:"buybar__content clear"},[_c('van-button',{staticClass:"fs3",attrs:{"type":"primary","size":"large"}},[_vm._v("提交申请")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-174aa17b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheBtnBar.vue
// module id = null
// module chunks = 